import { defineStore } from 'pinia'
import state from '@/stores/resources/state'
import actionsStore from '@/stores/resources/actions'
import gettersStore from '@/stores/resources/getters'
import mutationsStore from '@/stores/resources/mutations'

export const useResourceStore = defineStore('resource', () => {
  const getters = gettersStore(state)
  const mutations = mutationsStore(state)
  const actions = actionsStore(mutations)
  return {
    state,
    getters,
    mutations,
    actions,
  }
})
